export default "__VITE_ASSET__fQZYPbj3__"